
export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-r from-red-50 to-green-50 border-t border-red-100 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-lg font-semibold text-red-600 mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              🎅 Santa's Helper
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Your magical Christmas companion for organizing wishlists, tracking gift budgets, and making sure 
              Santa knows exactly what you're hoping for this holiday season.
            </p>
            <p className="text-red-500 text-sm mt-2 font-medium">🎁 Making Christmas wishes come true, one gift at a time</p>
          </div>
          
          <div>
            <h4 className="font-semibold text-gray-800 mb-4">Wishlist Features</h4>
            <div className="flex items-center space-x-2 text-sm text-gray-600 mb-2">
              <i className="ri-gift-fill text-red-500"></i>
              <span>Organize gifts by category</span>
            </div>
            <div className="flex items-center space-x-2 text-sm text-gray-600 mb-2">
              <i className="ri-star-fill text-green-500"></i>
              <span>Set gift priorities</span>
            </div>
            <div className="flex items-center space-x-2 text-sm text-gray-600">
              <i className="ri-heart-fill text-red-500"></i>
              <span>Mark your favorites</span>
            </div>
          </div>
        </div>
        
        <div className="border-t border-red-200 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-left mb-4 md:mb-0">
              <p className="text-gray-600 text-sm">
                🎄 Santa's Helper was lovingly created as a gift from Brian
              </p>
              <p className="text-gray-500 text-xs mt-1">
                Ho ho ho! Wishing you the most magical Christmas season! 🎅✨
              </p>
            </div>
            <div className="text-center md:text-right">
              <p className="text-gray-500 text-sm">
                © 2024 Santa's Helper. Spreading Christmas magic everywhere! 🎅
                <a href="https://readdy.ai/?origin=logo" className="ml-2 text-red-500 hover:text-red-600 transition-colors">Powered by Readdy</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
